import { SecureConfigService } from "../SecureConfigService";

export const environment = {
  production: true,
  apiUrl: 'https://api.fitbulut.com/CloudRestAPI/',
  authToken : SecureConfigService.getInstance().getAuthTokenProd(),
  env : "prod"
};
